import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('Game4Store')
@observer
export default class Game4Step2 extends Component {

    chooseNumber(number) {
        this.props.Game4Store.setPlayers(number);
    }

    render() {

        const {
            players,
            numberPlayers
        } = this.props.Game4Store;

        return (
            <div className="step-2">
                <h1>Number Of Teams</h1>
                <div className="buttons">
                    <button
                        className={numberPlayers === 2 ?  " selected": ""}
                        onClick={this.chooseNumber.bind(this, 2)}>2</button>
                    <button
                        className={numberPlayers === 3 ?  " selected": ""}
                        onClick={this.chooseNumber.bind(this, 3)}>3</button>
                </div>
            </div>
        )
    }

};



// WEBPACK FOOTER //
// ./src/containers/Game4/Game4Step2.js